import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export const SuccessMsg = (message) => {
  toast.success(message, {
    position: toast.POSITION,
    autoClose: 3000,
    hideProgressBar: false,
  });
};

export const WarningMsg = (message) => {
  toast.warn(message, {
    position: toast.POSITION,
    autoClose: 3000,
    hideProgressBar: false,
  });
};

export const ErrorMsg = (message) => {
  toast.error(message, {
    position: toast.POSITION,
    autoClose: 3000,
    hideProgressBar: false,
  });
};
